var map = {
	"./audio-placeholder": 637,
	"./audio-placeholder.png": 637,
	"./avatar-missing": 513,
	"./avatar-missing.png": 513,
	"./avatar-missing.svg": 958,
	"./header-missing": 533,
	"./header-missing.png": 533,
	"./soapbox-logo": 534,
	"./soapbox-logo-white": 535,
	"./soapbox-logo-white.svg": 535,
	"./soapbox-logo.svg": 534,
	"./video-placeholder": 638,
	"./video-placeholder.png": 638,
	"./void": 639,
	"./void.png": 639,
	"./web-push/web-push-icon_expand": 670,
	"./web-push/web-push-icon_expand.png": 670,
	"./web-push/web-push-icon_favourite": 671,
	"./web-push/web-push-icon_favourite.png": 671,
	"./web-push/web-push-icon_reblog": 672,
	"./web-push/web-push-icon_reblog.png": 672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 957;